<template>
  <div>
    <v-client-table
      :columns="columns"
      :data="data"
      :options="options"
      :theme="theme"
      id="StockTable"
      ref="table"
    >
      <template slot="condition" slot-scope="props">
        <b-badge pill :variant="getBadge(props.row.condition)">{{
          props.row.condition
        }}</b-badge>
      </template>
      <template slot="daystay" slot-scope="props">
        <div style="text-align: right">
          <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
            {{ props.row.daystay }}
          </b-badge>
        </div>
      </template>
      <div slot="afterFilter">
        <b-row class="ml-2">
          {{ data[0].origin_name }}({{ data[0].origin_code }}) >
          {{ data[0].product_name }} > {{ data[0].variety_name }} >
          {{ data[0].condition }}
        </b-row>
      </div>

      <div slot="net_kilograms" slot-scope="props">
        <div style="text-align: right">
          {{ props.row.net_kilograms.format("0,0.00") }}
        </div>
      </div>
      <div slot="pallet_clone" slot-scope="props" style="text-align: center">
        <div>
          <a
            target="_blank"
            href="#"
            @click.prevent="createSimiliarInsidePallet(props.row)"
            class="fa fa-lg fa-plus-circle text-primary"
          >
          </a
          >&nbsp;
        </div>
      </div>
      <div slot="pallet_number" slot-scope="props">
        <div>{{ props.row.pallet_number }} &nbsp;</div>
      </div>
      <div slot="quantity" slot-scope="props">
        <div style="text-align: right">{{ props.row.quantity }}</div>
      </div>
      <div slot="waybill_number" slot-scope="props">
        <div style="text-align: right">{{ props.row.waybill_number }}</div>
      </div>
      <div slot="waybill_date" slot-scope="props">
        <div style="text-align: right">{{ props.row.waybill_date }}</div>
      </div>
      <div slot=" " slot-scope="props">
        &nbsp;
        <a
          v-if="props.row.product_type_name != 'MERMA'"
          target="_blank"
          @click.prevent="editComponent(props.row)"
          href="#"
          class="fa fa-lg fa-pencil text-primary"
        ></a
        >&nbsp;
        <a
          v-if="props.row.product_type_name != 'MERMA'"
          target="_blank"
          href="#"
          @click.prevent="printContent(props.row.pallet)"
          class="fa fa-lg fa-print text-primary"
        ></a
        >&nbsp;
        <a
          target="_blank"
          @click.prevent="deleteContent(props.row.id)"
          href="#"
          class="fa fa-lg fa-trash text-danger"
        ></a>
      </div>
    </v-client-table>
    <print-modal :pallet_id="pallet_id"></print-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import AgregarContenidoModal from "./AgregarContenidoModal";
import numeral from "numeral";
import locales from "numeral/locales";
import { bus } from "../../main";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import PrintModal from "./PrintModal";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

Vue.use(ClientTable);

export default {
  name: "ProcessedTable",
  components: {
    ClientTable,
    AgregarContenidoModal,
    PrintModal
  },
  props: ["data", "tableType", "processId"],
  data() {
    return {
      pallet_id: 0,
      columns: [
        "pallet_clone",
        "pallet_number",
        "lot_number",
        // 'origin_name',
        // 'product_name',
        "product_type_name",
        // 'condition',
        // 'variety_name',
        "container_name",
        "string_specs",
        "quantity",
        "net_kilograms",
        " "
      ],
      allMarked: false,
      markedRows: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        filterByColumn: false,
        headings: {
          pallet_clone: "Clonar Pallet",
          pallet_number: "Pallet",
          lot_number: "Lote",
          product_name: "Producto",
          product_type_name: "Tipo Producto",
          condition: "Condición",
          variety_name: "Variedad",
          container_name: "Contenedor",
          quantity: "Cantidad",
          net_kilograms: "kilogramos netos",
          daystay: "Día de estancia",
          string_specs: "Especificaciones",
          origin_name: "Origen"
        },
        sortable: ["number", "company_name"],
        filterable: [
          "pallet_number",
          "product_name",
          "product_type_name",
          "variety_name",
          "container_name",
          "string_specs",
          "origin_name"
        ],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  computed: {
    sumMarkedKilograms() {
      let total = 0;
      total += this.markedRows.reduce(
        (acc, item) => acc + item.net_kilograms.value(),
        0
      );
      total = numeral(total);
      return total;
    },
    sumNetKilograms() {
      let total = 0;
      total += this.data.reduce(
        (acc, item) => acc + item.net_kilograms.value(),
        0
      );
      total = parseFloat(total.toFixed(2));
      total = numeral(total);
      return total;
    }
  },
  watch: {
    sumMarkedKilograms(val) {
      this.$emit("sumMarkedKilograms", this.sumMarkedKilograms);
    },
    sumNetKilograms(val) {
      this.$emit("sumNetKilograms", this.sumNetKilograms);
    }
  },
  methods: {
    editComponent(data) {
      bus.$emit("componentEditing", data);
    },
    printContent(data) {
      this.pallet_id = data;
      this.$nextTick(() => {
        this.$bvModal.show("modal-prevent-closing");
      });
    },
    createSimiliarInsidePallet(data) {
      bus.$emit("createSimiliarInsidePallet", data);
    },
    getBadge(condition) {
      return condition === "Orgánico" ? "primary" : "success";
    },
    getDaystayBadge(daystay) {
      return daystay >= 10
        ? "danger"
        : daystay >= 5
        ? "warning"
        : daystay >= 3
        ? "success"
        : "primary";
    },
    unmarkAll() {
      this.allMarked = false;
    },
    toggleAll() {
      this.markedRows = this.allMarked ? this.$refs.table.data : [];
    },
    deleteContent(a) {
      this.$axios
        .delete("/api/v1/content/" + a + "/")
        .then((res) => {
          miniToastr.success("Operación realizada con exito", "");

          let deleteIndex = this.data.findIndex((item) => item.id === a);

          this.data.splice(deleteIndex, 1);
        })
        .catch((error) => console.log(error));

      const formData = {
        contenido_id: a,
        tipo: 3
      };

      axios
        .post("/api/v1/process/traceability_process/", formData)
        .then((res) => {
          //console.log(res)
        })
        .catch((error) => console.log(error.message));
    },
    validateMarkedRows() {
      if (this.data.length > 0) {
        return 1;
      } else {
        return 0;
      }
    }
  }
};
</script>

<style lang="scss">
#StockTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
